import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageContentManual } from '../page-content-manual';
import { log } from 'console';


@Component({
    selector: 'app-user-manual',
    templateUrl: './user-manual.component.html',
    styleUrls: ['./user-manual.component.css'],
    standalone: false
})
export class UserManualComponent implements OnInit {

  languageList = require('../page-content-manual').languageList;
  content = require("../page-content-manual").content;
  // currentURL: String = "assets/user-manual/UserManualBN.pdf";
  pdfSrcEN="assets/user-manual/Guideline for eReturn_V1.1_25.pdf";
  // pdfSrcBN="assets/user-manual/UserManualBN.pdf";


  constructor(private router:Router) { }
  isLoading: boolean = true;
  EN:boolean = true;
  BN:boolean = false;


  ngOnInit(): void {

  }

  languageClick(code: string) {
    PageContentManual.selectedLanguageCode = code;

    if (Number(code) === 0) {
      this.BN = true;
      this.EN = false;
    }

    if (Number(code) === 1) {
      this.EN = true;
      this.BN = false;
    }
  }

  getSelectedLanguagesCode(): string {
    return PageContentManual.selectedLanguageCode;
  }

  onBacktoMainPage() {
    localStorage.clear();
    this.router.navigate(["/auth/sign-in"]);
  }

  afterLoadComplete(pdf: any) {
    this.isLoading = false;
    console.log("spinner working");


  }

}
